var React = require('react');

function Top (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"组_3576","data-name":"组 3576","transform":"translate(8318.482 5616.242) rotate(180)"},[React.createElement("path",{"id":"路径_2642","data-name":"路径 2642","d":"M8302,5513v30.219","transform":"translate(6.773 64.708)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("path",{"id":"路径_2643","data-name":"路径 2643","d":"M8299.348,5553.8l9.43,8.861,9-8.861","transform":"translate(-0.001 46.194)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1}),React.createElement("path",{"id":"路径_3483","data-name":"路径 3483","d":"M8299.348,5553.8l9.43,8.861,9-8.861","transform":"translate(0 52.194)","fill":"none","stroke":"#fff","strokeWidth":"2","key":2})]));
}

Top.defaultProps = {"width":"19.82","height":"38.533","viewBox":"0 0 19.82 38.533"};

module.exports = Top;

Top.default = Top;
